import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrmRoutingModule } from './crm-routing.module';
import { CoreModule } from 'src/app/core/core.module';
import { ContactsComponent } from './contacts/contacts.component';
import { CreateContactComponent } from './contacts/create-contact/create-contact.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ContactService } from 'src/app/core/services/contact.service';
import { ContactOverviewComponent } from './contacts/contact-overview/contact-overview.component';
import { NgbPopoverModule, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationsComponent } from './organizations/organizations.component';
import { OrganizationService } from 'src/app/core/services/organization.service';
import { CreateOrganizationComponent } from './organizations/create-organization/create-organization.component';
import { OrganizationOverviewComponent } from './organizations/organization-overview/organization-overview.component';
import { OrganizationContacts } from './organizations/organization-overview/organization-contacts/organization-contacts';
import { OrganizationProjects } from './organizations/organization-overview/organization-projects/organization-projects';
import { AddProjectComponent } from './organizations/organization-overview/organization-projects/add-project/add-project.component';
import { GoodsComponent } from './goods/goods.component';
import { InventoryItemService } from 'src/app/core/services/inventory-item.service';
import { InventoryItemOverviewComponent } from './goods/inventory-item-overview/inventory-item-overview.component';
import { InventoryItemInfoTabComponent } from './goods/inventory-item-overview/inventory-item-info-tab/inventory-item-info-tab.component';
import { InventoryItemFinancesTabComponent } from './goods/inventory-item-overview/inventory-item-finances-tab/inventory-item-finances-tab.component';
import { InventoryItemIdentificationTabComponent } from './goods/inventory-item-overview/inventory-item-identification-tab/inventory-item-identification-tab.component';
import { InventoryItemDescriptionTabComponent } from './goods/inventory-item-overview/inventory-item-description-tab/inventory-item-description-tab.component';
import { InventoryItemFilesTabComponent } from './goods/inventory-item-overview/inventory-item-files-tab/inventory-item-files-tab.component';
import { InventoryItemWarehouseTabComponent } from './goods/inventory-item-overview/inventory-item-warehouse-tab/inventory-item-warehouse-tab.component';
import { InventoryItemImageViewerComponent } from './goods/inventory-item-overview/inventory-item-image-viewer/inventory-item-image-viewer.component';
import { InventoryItemHistoryPanelComponent } from './goods/inventory-item-overview/inventory-item-history-panel/inventory-item-history-panel.component';
import { InventoryItemUomAndPricesTabComponent } from './goods/inventory-item-overview/inventory-item-uom-and-prices-tab/inventory-item-uom-and-prices-tab.component';
import { InventoryItemComponentsTabComponent } from './goods/inventory-item-overview/inventory-item-components-tab/inventory-item-components-tab.component';
import { OrganizationSalesPricesTabComponent } from './organizations/organization-overview/organization-sales-prices-tab/organization-sales-prices-tab.component';
import { OrganizationSalesOrdersTabComponent } from './organizations/organization-overview/organization-sales-orders-tab/organization-sales-orders-tab.component';
import { OrganizationSalesOrderOverviewComponent } from './organizations/organization-sales-order-overview/organization-sales-order-overview.component';
import { CreateGoodsComponent } from './goods/create-goods/create-goods.component';
import { ToastsContainerComponent } from 'src/app/core/components/toast/toasts-container.component';
import { InventoryItemAttachmentService } from 'src/app/core/services/inventory-item-attachment.service';
import { ContactDeliveryAddressesSectionComponent } from './contacts/contact-overview/contact-delivery-addresses-section/contact-delivery-addresses-section.component';
import { SalesOrdersComponent } from './sales-orders/sales-orders.component';
import { SalesOrderOverviewComponent } from './sales-orders/sales-order-overview/sales-order-overview.component';
import { ShipmentsComponent } from './shipments/shipments.component';
import { ShipmentOverviewComponent } from './shipments/shipment-overview/shipment-overview.component';

@NgModule({
  declarations: [
    ContactsComponent,
    ContactOverviewComponent,
    OrganizationsComponent,
    CreateOrganizationComponent,
    OrganizationOverviewComponent,
    GoodsComponent,
    CreateGoodsComponent,
    InventoryItemOverviewComponent,
    OrganizationSalesPricesTabComponent,
    OrganizationSalesOrdersTabComponent,
    OrganizationSalesOrderOverviewComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbPopoverModule,
    NgbTypeaheadModule,
    NgbTooltipModule,
    CoreModule,
    CrmRoutingModule,
    ToastsContainerComponent,
    ContactDeliveryAddressesSectionComponent,
    CreateContactComponent,
    SalesOrdersComponent,
    SalesOrderOverviewComponent,
    ShipmentsComponent,
    ShipmentOverviewComponent,
    InventoryItemInfoTabComponent,
    InventoryItemFinancesTabComponent,
    InventoryItemIdentificationTabComponent,
    InventoryItemDescriptionTabComponent,
    InventoryItemFilesTabComponent,
    InventoryItemWarehouseTabComponent,
    InventoryItemImageViewerComponent,
    InventoryItemHistoryPanelComponent,
    InventoryItemUomAndPricesTabComponent,
    InventoryItemComponentsTabComponent,
    OrganizationContacts,
    OrganizationProjects,
    AddProjectComponent,
  ],
  providers: [ContactService, OrganizationService, InventoryItemService, InventoryItemAttachmentService]
})
export class CrmModule {}
